export const ChartMarkers = [
    'circle',
    'square',
    'diamond',
    'triangle',
    'triangle-down'
];
